import { cpl } from "../../models/FullReportEntry";
import { buildCategoryFilter, CategoryFilter } from "./category-filters";
import { FilterAction } from "./FilterAction";

const clusterFilters:Record<string, CategoryFilter> = {
    "CPL": {
        "Excelente (até R$ 9,99)": (a) => cpl(a) < 10,
        "Moderado (R$ 10,00 a R$ 14,99)": (a) => cpl(a) >= 10 && cpl(a) < 15, 
        "Ruim (R$ 15,00 a R$ 19,99)": (a) => cpl(a) >= 15 && cpl(a) < 20, 
        "Péssimo (>= R$ 20,00)": (a) => cpl(a) >= 20 
    }
}


export const [clusterFilter, ClusterFilterMenu] = buildCategoryFilter(clusterFilters, FilterAction.setCluster, "Clusters...");